/** @jsx jsx */
import React, { useCallback, useEffect } from 'react';
import { jsx } from '@emotion/core';

import ActionButtonsContainer from 'components/ActionButtonsContainer';
import { FormikProps } from 'formik';
import { FormValues } from './UnifiedPrequalOffer';

import useTranslate, {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';

import styles from './styles';
import { Divider } from '@material-ui/core';
import Button from 'components/Button';
import Link from 'components/Link';
import ExpandablePanel from 'components/ExpandablePanel';

import useAnalytics, { Event } from 'hooks/useAnalytics';
import useAnalyticVariables from 'hooks/useAnalyticVariables';
import BreadTitle from '../OfferIntro/BreadTitle';

interface CreditCardNotPreapprovedProps {
  formikProps: FormikProps<FormValues>;
  panelName: string;
  expanded: boolean;
  nextPath: string;
  handlePanelExpandChange: (
    event: React.ChangeEvent<{}>,
    panelName: string,
    expanded: boolean,
  ) => void;
}

// FIXME: why is this called NotPreapproved when it's shown when notQualified
// is true?
const CreditCardNotPreapproved: React.FC<
  CreditCardNotPreapprovedProps
> = props => {
  const {
    panelName,
    nextPath,
    expanded,
    handlePanelExpandChange,
    formikProps,
  } = props;
  const tMd = useMarkdownTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();
  const t = useTranslate();

  const handleClick = useCallback(async () => {
    formikProps.submitForm();
  }, [formikProps]);

  const { sendEvents } = useAnalytics();
  const { setAnalyticsVariables } = useAnalyticVariables();

  useEffect(() => {
    expanded && sendEvents([Event.PrequalNotQualifiedExpanded]);
  }, [expanded, sendEvents, setAnalyticsVariables]);

  const title = (
    <div>
      <div css={styles.paymentOption.summaryTitle}>
        <BreadTitle
          id={'CreditCardNotPreapprovedBreadLogo'}
          titlePart={
            <React.Fragment>
              {tMd(
                'unified.offer.paymentOption.creditCard.notPreapproved.title',
              )}
              {t('unified.creditCardLogo') !== '' && (
                <img
                  src={`data:image/png;base64,${t('unified.creditCardLogo')}`}
                  alt={t('unified.creditCardLogoAlt')}
                  css={styles.paymentOption.cardIcon}
                />
              )}
            </React.Fragment>
          }
          logo={t(
            'unified.offer.paymentOption.creditCard.notPreapproved.breadLogo',
          )}
        />
      </div>
      <div css={styles.paymentOption.summaryBody}>
        {/*Get <span css={styles.boldColorText}>120.00 off</span> this purchase
        when you get 20% off your first Nebella purchase with the Nebella Credit
        Card*/}
        {tMdMultiline(
          'unified.offer.paymentOption.creditCard.notPreapproved.description',
        )}
      </div>
    </div>
  );

  const body = (
    <div css={styles.paymentOption.body}>
      <div css={styles.paymentOption.section}>
        <Divider />
      </div>
      <div css={styles.paymentOption.section}>
        {tMd('unified.offer.paymentOption.creditCard.notPreapproved.message')}
      </div>
    </div>
  );

  const footer = (
    <React.Fragment>
      <ActionButtonsContainer>
        <Button
          mobileFullWidth={true}
          id="creditCardAcceptOffer"
          component={Link}
          disabled={!formikProps.isValid || formikProps.isSubmitting}
          onClick={handleClick}
          to={nextPath}
        >
          {tMd(
            'unified.offer.paymentOption.creditCard.notPreapproved.applyButton',
          )}
        </Button>
      </ActionButtonsContainer>
    </React.Fragment>
  );
  return (
    <ExpandablePanel
      title={title}
      children={body}
      footer={footer}
      panelName={panelName}
      expanded={expanded}
      onChange={handlePanelExpandChange}
      banner={tMd(
        'unified.offer.paymentOption.creditCard.notPreapproved.banner',
      )}
    />
  );
};

export default CreditCardNotPreapproved;
